import {
  SravniNewsSharedModelsLikesLikeUpdateModel,
  SravniNewsSharedModelsLikesUserLikesResult,
  UserSelfLikesListParams,
} from '../__generated__/news/Api';

import { ProxyClient } from './client/ProxyClient';

export const getUserLikes = async (params: UserSelfLikesListParams) => {
  const { data } = await ProxyClient.get<SravniNewsSharedModelsLikesUserLikesResult>('/likes/user', { params });
  return data;
};

export const postLike = async (data: SravniNewsSharedModelsLikesLikeUpdateModel) => {
  await ProxyClient.post('/likes/post', data);
};

export const deleteLike = async (query: SravniNewsSharedModelsLikesLikeUpdateModel) => {
  await ProxyClient.delete('/likes/delete', {
    params: query,
  });
};

export const getArticleLikes = async (articleId) => {
  const { headers } = await ProxyClient.head(`/likes/articleLikes/get/${articleId}`, {
    method: 'HEAD',
  });
  return +headers.total;
};
